
import { mapGetters } from "vuex";

export default {
  props: {
    brandName: {
      default: String,
      type: ""
    },

    sizeProp: {
      type: Number,
      default: 28
    }
  },
  computed: {
    ...mapGetters("restaurant", ["getAllBrands", "getRestaurantName"]),
    getColor() {
      const index = this.getAllBrands.findIndex(
        (brand) => brand.name === this.brandName
      );
      return this.$constants.Colors.COLORS[
        index % this.$constants.Colors.COLORS.length
      ];
    }
  }
};
